import styled, { createGlobalStyle } from "styled-components";
import {
  mediaMinWidth,
  mediaMaxWidth,
} from "../../../theme/mediaQueriesTemplates";

export const RouterNav = styled.nav`
  position: fixed;
  top: 116px;
  width: calc(100% - 60px);
  margin-left: 60px;
  z-index: 1;
  background-color: #e4e5e7;
  height: 55px;
  align-items: center;
  transition: 0.2s ease-in-out;

  ${mediaMaxWidth.tablet} {
    width: 100%;
    margin-left: 0;

    &.downScroll {
      top: 57px;
    }
  }
`;

export const RouterList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 5px 0 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;

  ${mediaMaxWidth.tablet} {
    height: calc(100% - 5px);
    background-color: #fff;
  }
`;

export const DotContainer = styled.div`
  position: absolute;
  top: 8px;
  right: 4px;

  ${mediaMaxWidth.tablet} {
    top: 9px;
    right: calc(50% - 20px);
  }
`;

export const Dot = styled.div`
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background-color: #79D9D9;
  position: absolute;
  top: -2px;
  right: 0px;
`;

interface IRingProps {
  agents?: boolean;
  candidates?: boolean;
}

export const Ring = styled.div`
  border: 1px solid #79D9D9;
  border-radius: 50%;
  height: 15px;
  width: 14.5px;
  position: absolute;
  animation: ${(props: IRingProps) =>
    props.agents && "pulsate 5s ease-out infinite"};
  animation: ${(props: IRingProps) =>
    props.candidates && "pulsate 4.8s ease-out infinite"};
  opacity: 0;
  right: -3.5px;
  opacity: 0;
  top: -5.5px;

  @keyframes pulsate {
    0% {
      transform: scale(0.1, 0.1);
      opacity: 0;
    }

    5% {
      opacity: 1;
    }

    10% {
      transform: scale(1.2, 1.2);
      opacity: 0;
    }

    100% {
      transform: scale(0.1, 0.1);
      opacity: 0;
    }
  }
`;

export const RouterItem = styled.li`
  display: flex;
  justify-content: center;
  padding: 5px 15px;
  font-weight: 700;
  margin: 0 10px;
  flex-direction: column;
  position: relative;

  a {
    color: #333;

    &::after {
      content: "";
      display: block;
      width: 0;
      height: 5px;
      background: #79D9D9;
      transition: width 0.2s;
      position: relative;
      top: 5px;
      left: -15px;

      ${mediaMaxWidth.tablet} {
        top: 7px;
        left: -5px;
      }
    }

    &:hover {
      &::after {
        width: calc(100% + 30px);

        ${mediaMaxWidth.tablet} {
          width: calc(100% + 10px);
        }
      }
    }
  }

  a.active {
    &::after {
      content: "";
      display: block;
      width: calc(100% + 30px);
      height: 5px;
      background: #79D9D9;
      position: relative;
      top: 5px;
      left: -15px;

      ${mediaMaxWidth.tablet} {
        width: calc(100% + 10px);
        top: 7px;
        left: -5px;
      }
    }
  }

  ${mediaMaxWidth.tablet} {
    flex: 1;
    margin: 0;
    padding: 5px 5px;
    text-align: center;
  }
`;

export const TabIcon = styled.div`
  color: #4a4a4a;

  ${mediaMinWidth.tablet} {
    display: none;
  }
`;

export const TabText = styled.div`
  ${mediaMaxWidth.tablet} {
    text-transform: uppercase;
    font-size: 0.65em;
    font-weight: 600;
    position: relative;
    top: 3px;
  }
`;

export const GlobalStyle = createGlobalStyle`
  ${mediaMaxWidth.tablet} {
    body.tab-nav-active {
      #navbar {
        display: none;
        transition: 0s;
      }

      #job-index-filter {
        display: none;
      }

      #action-bar {
        top: 0;
        transition: 0s;
      }

      #job-options-button,
      #message-all-agencies-trigger {
        top: 12px;
        transition: 0s;
      }

      #tab-nav {
        top: 57px;
        transition: 0s;
      }

      #job-profile-wrapper {
        padding: 49px 0 0 0;
      }

      #agents-wrapper {
        padding: 60px 0 0 0;
      }

      #kanban-scroll-area {
        padding-top: 60px;
      }

      #mobile-bottom-nav {
        display: none;
      }
    }
  }
`;
